// Response fencing complements cancellation: parsing can finish after abort or
// after switching away and back to the same account.
export function createPaperRequestScope(getContext) {
  let owner = null, ownerEpoch = 0, epoch = 0, batch = null;
  const channels = new Map();
  const invalidate = () => { epoch++; };
  const updateOwner = next => {
    if (next !== owner) { owner = next; ownerEpoch++; batch = null; channels.clear(); invalidate(); }
  };
  const selectBatch = next => { if (next !== batch) { batch = next; invalidate(); } };
  const capture = (channel, {ownerOnly = false, requestId = null, batchId = batch} = {}) => {
    const sequence = (channels.get(channel) || 0) + 1;
    channels.set(channel, sequence);
    return {owner, ownerEpoch, epoch, batch:batchId, channel, sequence, ownerOnly, requestId};
  };
  const active = token => {
    const current = getContext();
    return Boolean(token && current.mounted && token.owner && current.owner === token.owner && current.authOwner === token.owner &&
      token.ownerEpoch === ownerEpoch && token.owner === owner &&
      (token.ownerOnly || (token.epoch === epoch && token.batch === batch)) &&
      channels.get(token.channel) === token.sequence &&
      (!token.requestId || current.pendingRequestId === token.requestId));
  };
  return {invalidate, updateOwner, selectBatch, capture, active};
}
